import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

export default function AdminPage() {
  const [enquiries, setEnquiries] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/login');
      return;
    }

    fetchEnquiries(token);
  }, [navigate]);

  const fetchEnquiries = async (token) => {
    try {
      const response = await fetch('/api/enquiries', {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('token');
          navigate('/login');
          return;
        }
        throw new Error('Failed to fetch enquiries');
      }

      const data = await response.json();
      setEnquiries(data);
    } catch (error) {
      toast.error('Error fetching enquiries: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    toast.success('Logged out successfully');
    navigate('/login');
  };

  const handleDelete = async (id) => {
    const token = localStorage.getItem('token');
    if (!token) return;

    try {
      const response = await fetch(`/api/enquiries/${id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error('Failed to delete enquiry');
      }

      setEnquiries(enquiries.filter(e => e.id !== id));
      toast.success('Enquiry deleted successfully');
    } catch (error) {
      toast.error('Error deleting enquiry: ' + error.message);
    }
  };

  if (loading) {
    return <div style={{ textAlign: 'center', padding: '50px' }}>Loading...</div>;
  }

  return (
    <div style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px' }}>
        <h1 style={{ color: '#003151' }}>Admin Dashboard</h1>
        <button
          onClick={handleLogout}
          style={{
            padding: '10px 20px',
            backgroundColor: '#dc3545',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '14px',
          }}
        >
          Logout
        </button>
      </div>

      <div style={{ backgroundColor: 'white', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)', padding: '20px' }}>
        <h2 style={{ color: '#003151', marginBottom: '20px' }}>Contact Enquiries ({enquiries.length})</h2>

        {enquiries.length === 0 ? (
          <p style={{ color: '#666', textAlign: 'center', padding: '20px' }}>No enquiries yet</p>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ borderBottom: '2px solid #ddd', backgroundColor: '#f9f9f9' }}>
                  <th style={{ padding: '12px', textAlign: 'left', fontWeight: 'bold' }}>Name</th>
                  <th style={{ padding: '12px', textAlign: 'left', fontWeight: 'bold' }}>Email</th>
                  <th style={{ padding: '12px', textAlign: 'left', fontWeight: 'bold' }}>Phone</th>
                  <th style={{ padding: '12px', textAlign: 'left', fontWeight: 'bold' }}>Company</th>
                  <th style={{ padding: '12px', textAlign: 'left', fontWeight: 'bold' }}>Message</th>
                  <th style={{ padding: '12px', textAlign: 'left', fontWeight: 'bold' }}>Date</th>
                  <th style={{ padding: '12px', textAlign: 'center', fontWeight: 'bold' }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {enquiries.map((enquiry) => (
                  <tr key={enquiry.id} style={{ borderBottom: '1px solid #eee' }}>
                    <td style={{ padding: '12px' }}>{enquiry.name}</td>
                    <td style={{ padding: '12px' }}>
                      <a href={`mailto:${enquiry.email}`} style={{ color: '#003151', textDecoration: 'none' }}>
                        {enquiry.email}
                      </a>
                    </td>
                    <td style={{ padding: '12px' }}>
                      <a href={`tel:${enquiry.phone}`} style={{ color: '#003151', textDecoration: 'none' }}>
                        {enquiry.phone}
                      </a>
                    </td>
                    <td style={{ padding: '12px' }}>{enquiry.company || 'N/A'}</td>
                    <td style={{ padding: '12px', maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {enquiry.message}
                    </td>
                    <td style={{ padding: '12px' }}>
                      {new Date(enquiry.submitted_at).toLocaleDateString()}
                    </td>
                    <td style={{ padding: '12px', textAlign: 'center' }}>
                      <button
                        onClick={() => handleDelete(enquiry.id)}
                        style={{
                          padding: '6px 12px',
                          backgroundColor: '#dc3545',
                          color: 'white',
                          border: 'none',
                          borderRadius: '4px',
                          cursor: 'pointer',
                          fontSize: '12px',
                        }}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}